import { render, staticRenderFns } from "./Plazas.vue?vue&type=template&id=175f2024&scoped=true&"
import script from "./Plazas.vue?vue&type=script&lang=js&"
export * from "./Plazas.vue?vue&type=script&lang=js&"
import style0 from "./Plazas.vue?vue&type=style&index=0&id=175f2024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175f2024",
  null
  
)

export default component.exports